<section class="flex justify-center">
  <div
    class="max-w-[1440px] w-full py-[48px] px-[24px] md:py-[80px] md:px-[64px]"
  >
    <div class="flex flex-col xl:flex-row xl:justify-between gap-10">
      <div
        class="flex flex-col gap-4 text-center md:text-left xl:max-w-[500px]"
      >
        <div class="text-G900 text-h4 md:text-h3 font-medium">
          {{ joinSection.title }}
        </div>
        <div class="text-G700 text-b1">
          {{ joinSection.subTitle }}
        </div>
      </div>
      <div class="flex justify-center w-full">
        <div class="flex flex-wrap justify-center gap-8 max-w-full">
          <a
            *ngFor="let community of joinSection.communities"
            class="bg-G200 hover:bg-G300 click:bg-G300 w-full max-w-[332px] md:w-[332px] border border-G300 rounded-[16px] py-[24px] px-[24px] sm:py-[32px] sm:px-[48px] flex justify-between items-center gap-4 shadow-community cursor-pointer transition-all duration-200"
            href="{{ community.url }}"
            target="_blank"
          >
            <img
              src="{{ community.imgSrc }}"
              class="w-[64px] h-[64px] select-none"
            />
            <div class="flex flex-col gap-2">
              <div class="text-G700 text-b2 whitespace-nowrap">
                {{ community.title }}
              </div>
              <div class="text-G900 text-b1 font-medium whitespace-nowrap">
                {{ community.description }}
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
